import { type ReactNode } from 'react';
import { Box, Column, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface ISectionCardProps {
  title: string;
  headerRight?: ReactNode;
  children: ReactNode;
  testId?: string;
}

export const SectionCard = ({ title, headerRight, children, testId }: ISectionCardProps) => (
  <Column
    data-testid={testId}
    backgroundColor={Colors.white}
    border={`1.5px solid ${Colors.neutral_100}`}
    borderRadius={8}
    padding="28px 28px 36px 28px"
  >
    <Row justifyContent="space-between" alignItems="center">
      <Text bold fontSize={24}>
        {title}
      </Text>
      {headerRight}
    </Row>

    <Box height={1.5} backgroundColor={Colors.neutral_100} marginTop={8} marginBottom={20} />

    {children}
  </Column>
);
